import { Gabarito } from '../../models/gabarito.model';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GabaritoUserService {

  baseUrlSite = environment.baseUrlSite;

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  public create(gabarito: any): Observable<Gabarito> {
    const service = 'gabaritos';
    return this.http.post<Gabarito>(this.baseUrlSite + service, gabarito);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
